import React from "react";
import Link from "@/components/LocalizedLink";
import { useTranslation } from "react-i18next";
import { Coffee, ArrowRight, Mail } from "lucide-react";

const StoryBox = () => {
  const { t } = useTranslation();
  return (
    <section
      id="storia-home"
      className="section-y"
      style={{ background: "#fbf5e9" }}
      data-testid="story-box"
    >
      <div className="max-w-6xl mx-auto px-6 lg:px-8">
        <div
          className="relative rounded-3xl overflow-hidden shadow-2xl"
          style={{
            background:
              "linear-gradient(155deg, #3b2417 0%, #2a160c 55%, #1d0f08 100%)",
            border: "1px solid rgba(245,234,214,0.08)",
            boxShadow: "0 40px 80px -30px rgba(42,22,12,0.55)",
          }}
        >
          {/* Decorative coffee beans in corners */}
          <div className="absolute inset-0 pointer-events-none opacity-[0.06]">
            {[
              { top: "10%", left: "6%", rot: -20, size: 32 },
              { top: "20%", right: "8%", rot: 25, size: 24 },
              { bottom: "12%", left: "10%", rot: 40, size: 28 },
              { bottom: "18%", right: "6%", rot: -15, size: 36 },
            ].map((b, i) => (
              <span
                key={i}
                className="absolute rounded-full"
                style={{
                  top: b.top,
                  left: b.left,
                  right: b.right,
                  bottom: b.bottom,
                  width: b.size,
                  height: b.size * 1.4,
                  background: "#f5ead6",
                  transform: `rotate(${b.rot}deg)`,
                }}
              />
            ))}
          </div>

          <div className="relative px-6 sm:px-10 lg:px-16 py-14 sm:py-16 lg:py-20 text-center">
            {/* Small icon accent */}
            <div className="flex justify-center mb-6">
              <div
                className="inline-flex items-center justify-center w-14 h-14 rounded-full"
                style={{ background: "#c5371f", boxShadow: "0 10px 24px -6px rgba(197,55,31,0.6)" }}
              >
                <Coffee size={22} color="#fff" />
              </div>
            </div>

            <span
              className="font-serif-display uppercase tracking-[0.35em] text-xs sm:text-sm"
              style={{ color: "#c5371f" }}
            >
              {t("storyBox.eyebrow")}
            </span>

            <h2
              className="font-serif-display font-bold mt-4 leading-tight"
              style={{ color: "#fbf5e9", fontSize: "clamp(1.7rem, 3.2vw, 2.8rem)" }}
            >
              {t("storyBox.title")}
            </h2>

            <div className="mt-6 flex items-center justify-center gap-3">
              <span className="h-px w-10" style={{ background: "#c5371f" }} />
              <span className="h-1.5 w-1.5 rounded-full" style={{ background: "#c5371f" }} />
              <span className="h-px w-10" style={{ background: "#c5371f" }} />
            </div>

            <div
              className="mt-8 max-w-3xl mx-auto space-y-5 text-[15px] sm:text-lg leading-relaxed text-left sm:text-center"
              style={{ color: "#f5ead6" }}
            >
              <p dangerouslySetInnerHTML={{ __html: t("storyBox.p1") }} />
              <p dangerouslySetInnerHTML={{ __html: t("storyBox.p2") }} />
              <p dangerouslySetInnerHTML={{ __html: t("storyBox.p3") }} />
            </div>

            {/* Buttons */}
            <div className="mt-10 flex flex-col sm:flex-row items-center justify-center gap-3 sm:gap-4">
              <Link
                to="/le-origini"
                className="btn-red focus-ring inline-flex items-center gap-2 px-8 py-3.5 rounded-full font-semibold uppercase tracking-wider text-sm"
                data-testid="story-cta-origini"
              >
                {t("storyBox.ctaOrigini")} <ArrowRight size={14} />
              </Link>
              <a
                href="#contatti"
                className="btn-outline-cream focus-ring inline-flex items-center gap-2 px-8 py-3.5 rounded-full font-semibold uppercase tracking-wider text-sm"
                data-testid="story-cta-contatti"
              >
                <Mail size={14} /> {t("storyBox.ctaContatti")}
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default StoryBox;
